import { api } from "@/lib/api";
import { lang } from "@/lib/i18n";

/* Этап 13: «Как пользоваться» — статьи docs/help/<lang>/*.md с бэкенда и помощник по ним (OpenRouter). */

export type HelpCard = { slug: string; title: string; section: string; order: number; summary: string };
export type HelpArticle = HelpCard & { lang: string; body: string };
export type HelpAnswer = { answer: string; sources: HelpCard[] };

export const helpApi = {
  list: () => api<{ items: HelpCard[]; ai: boolean }>(`/help?lang=${lang}`),
  article: (slug: string) => api<HelpArticle>(`/help/${encodeURIComponent(slug)}?lang=${lang}`),
  ask: (question: string) => api<HelpAnswer>("/help/ask", { method: "POST", json: { question, lang } }),
};
